import '../../LoadPickSubscribers.css';var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { connect } from "react-redux";
import { AsyncRequestStatus } from "@ane/core/lib/models/IAsyncWrapper/IAsyncWrapper";
import { SubscriberPicker } from "@ane/ui-components/lib/components/SubscriberPicker";
import { PeoplePickerItemSuggestion, ValidationState } from "@ane/ui-components/lib/components/Pickers";
import { SpinnerSize } from "@ane/ui-components/lib/components/Spinner";
import { MSFT_TENANT_ID, TORUS_TENANT_ID, TenantNamesById } from "@ane/core/lib/services/MSALAuthService/MSAL.constants";
import { getTheme } from "@ane/ui-components/lib/Styling";
import { ARIA_LABELS } from "./LoadPickSubscribers.types.js";
import { SUBSCRIPTION_TYPES } from "@ane/exp-data/lib/models/SubscriberModels";
import { loadSubscribersEpicReducer } from "./LoadSubscribers.epics.js";
import SubscriberResources from "@ane/exp-data/lib/resources/SubscriberResources";
import { getMergedSubscribers, convertSubscribersV2, convertSubscribers, convertSubscribersToUnified } from "./Subscriber.utils.js";
import ErrorBoundary from "@ane/ui-components/lib/components/ErrorBoundary/ErrorBoundary";
import { TIPS, ERROR_TYPES, EmailDomainList } from "./Subscriber.constants.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { loadSubscribersEpicReducerV2 } from "./LoadSubscribersV2.epics.js";
import { requestPending, requestCompleted } from "@ane/core/lib/models/IAsyncWrapper/IAsyncWrapper.utils";
const LoadPickSubscribers$1 = "";
const theme = getTheme();
const focusColor = theme.palette.blue;
const errorColor = theme.palette.redDark;
const defaultColor = theme.palette.neutralSecondary;
const pickerResultLimitDefault = 5;
const pickerResolveDelayDefault = 1500;
const mapState = (state) => ({
  subscribersAsync: state.subscribers.items,
  setSubscribersAsync: state.setSubscribers.value,
  subscribersAsyncV2: state.subscribersV2.items,
  setSubscribersAsyncV2: state.setSubscribersV2.value
});
const mapDispatch = {
  loadSubscribers: loadSubscribersEpicReducer.actionCreators.load,
  loadSubscribersV2: loadSubscribersEpicReducerV2.actionCreators.load
};
const labelProps = {
  text: TIPS.LABEL_TEXT,
  htmlFor: ""
};
const iconProps = {
  ariaLabel: ARIA_LABELS.ICON_HINT,
  iconName: "Info",
  calloutProps: {
    content: TIPS.ICON_CALLOUT_TEXT
  }
};
const spinnerProps = {
  ariaLabel: ARIA_LABELS.SUBSCRIBER_LOADING,
  label: TIPS.LOADING_TEXT,
  size: SpinnerSize.medium,
  labelPosition: "right"
};
const suggestionProps = {
  loadingText: TIPS.SUGGESTION_LOADING_TEXT,
  noResultsFoundText: TIPS.SUGGESTION_NO_RESULT_TEXT,
  suggestionsAvailableAlertText: TIPS.SUGGESTION_AVAILABLE_ALERT_TEXT,
  suggestionsContainerAriaLabel: ARIA_LABELS.SUGGESTED_RESULTS
};
const pickerCalloutProps = {};
const personaStyles = {
  root: {
    width: "auto"
  },
  primaryText: {
    width: "auto"
  },
  secondaryText: {
    width: "auto"
  }
};
class Component extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "pickerRef");
    __publicField(this, "resultLimit", !!this.props.pickerResultLimit ? this.props.pickerResultLimit : pickerResultLimitDefault);
    __publicField(this, "resolveDelay", !!this.props.pickerResolveDelay ? this.props.pickerResolveDelay : pickerResolveDelayDefault);
    __publicField(this, "tenantId", "");
    __publicField(this, "renderSubscriberPicker", () => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
      const checkboxProps = {
        ariaLabel: ARIA_LABELS.SUBSCRIBE_ME_CHECKBOX,
        label: TIPS.CHECKBOX_LABEL,
        onChange: this.onCheckBoxChange,
        checked: this.IsUserInSubscribers(),
        disabled: !!this.props.disableCheckBox
      };
      const loadingProps = EnvironmentService.enableUnifiedAPIOfSubscribeMode() ? {
        status: !!this.props.subscribersAsyncV2 ? this.props.subscribersAsyncV2.status : AsyncRequestStatus.NotStarted,
        data: (_a = this.props.subscribersAsyncV2) == null ? void 0 : _a.data,
        failed: {
          heading: "There was an error",
          message: (_b = this.props.subscribersAsyncV2) == null ? void 0 : _b.error
        },
        spinnerProps
      } : {
        status: !!this.props.subscribersAsync ? this.props.subscribersAsync.status : AsyncRequestStatus.NotStarted,
        data: (_c = this.props.subscribersAsync) == null ? void 0 : _c.data,
        failed: {
          heading: "There was an error",
          message: (_d = this.props.subscribersAsync) == null ? void 0 : _d.error
        },
        spinnerProps
      };
      const dropdownProps = {
        ariaLabel: ARIA_LABELS.DOMAIN_DROPDOWN,
        selectedKeys: this.state.selectedKeys,
        multiSelect: true,
        options: this.getDropdownOptions(this.tenantId),
        styles: { title: { border: "0px", outline: "0px" }, dropdown: { width: "120px" } },
        onChange: this.onDomainDropdownChange
      };
      const peoplePickerStyles = this.state.isFocus ? {
        text: {
          border: "1px solid",
          outlineColor: !!this.state.errorMessage ? errorColor : focusColor
        }
      } : {
        text: {
          border: "1px solid",
          borderColor: !!this.state.errorMessage ? errorColor : defaultColor
        }
      };
      const inputProps = EnvironmentService.enableUnifiedAPIOfSubscribeMode() ? {
        placeholder: ((_e = this.props.subscribersAsyncV2) == null ? void 0 : _e.status) === AsyncRequestStatus.Pending || ((_f = this.props.subscribersAsyncV2) == null ? void 0 : _f.status) === AsyncRequestStatus.Failed || !!this.props.isReadOnly ? "" : TIPS.INPUT_PLACEHOLDER,
        onClick: this.onInputClick,
        onFocus: (ev) => {
          this.setState({ isFocus: true });
        }
      } : {
        placeholder: ((_g = this.props.subscribersAsync) == null ? void 0 : _g.status) === AsyncRequestStatus.Pending || ((_h = this.props.subscribersAsync) == null ? void 0 : _h.status) === AsyncRequestStatus.Failed || !!this.props.isReadOnly ? "" : TIPS.INPUT_PLACEHOLDER,
        onClick: this.onInputClick,
        onFocus: (ev) => {
          this.setState({ isFocus: true });
        }
      };
      const peoplePickerProps = {
        componentRef: this.pickerRef,
        key: "peoplePicker",
        selectionAriaLabel: ARIA_LABELS.PICKER_SELECTION,
        removeButtonAriaLabel: ARIA_LABELS.SUBSCRIBER_REMOVE,
        inputProps,
        pickerSuggestionsProps: suggestionProps,
        pickerCalloutProps,
        resolveDelay: this.resolveDelay,
        selectedItems: this.state.currentSelected.map((item) => __spreadProps(__spreadValues({}, item), {
          disabled: !!item.subscriptionType && item.subscriptionType !== SUBSCRIPTION_TYPES.EntityBase
        })),
        onResolveSuggestions: this.onFilterChanged,
        onRenderSuggestionsItem: this.onRenderSuggestionItem,
        onChange: this.onItemsChange,
        onValidateInput: this.validateInput,
        onInputChange: this.onInputChange,
        onBlur: this.onInputBlur,
        styles: peoplePickerStyles
      };
      if (!!this.props.shouldReset) {
        if (EnvironmentService.enableUnifiedAPIOfSubscribeMode() && ((_i = this.props.subscribersAsyncV2) == null ? void 0 : _i.status) === AsyncRequestStatus.Completed) {
          let subscribers = getMergedSubscribers(
            this.props.subscribersAsyncV2.data,
            this.props.notificationCategory,
            this.props.experimentationGroupId
          );
          peoplePickerProps.selectedItems = convertSubscribersV2(subscribers);
        } else if (!EnvironmentService.enableUnifiedAPIOfSubscribeMode() && ((_j = this.props.subscribersAsync) == null ? void 0 : _j.status) === AsyncRequestStatus.Completed) {
          peoplePickerProps.selectedItems = convertSubscribers((_l = (_k = this.props.subscribersAsync) == null ? void 0 : _k.data) == null ? void 0 : _l.subscribers);
        }
      }
      let notPending = EnvironmentService.enableUnifiedAPIOfSubscribeMode() ? !requestPending((_m = this.props.setSubscribersAsyncV2) == null ? void 0 : _m.status) : !requestPending((_n = this.props.setSubscribersAsync) == null ? void 0 : _n.status);
      const useCheckBoxProps = !!this.props.isReadOnly && notPending;
      return /* @__PURE__ */ jsx(
        SubscriberPicker,
        {
          ariaLabel: ARIA_LABELS.SUBSCRIBER_PICKER,
          required: this.props.required,
          isReadOnly: !!this.props.isReadOnly,
          peoplePickerProps,
          labelProps,
          iconProps,
          loadingProps,
          dropdownProps: this.tenantId === MSFT_TENANT_ID ? null : dropdownProps,
          checkboxProps: useCheckBoxProps ? checkboxProps : null,
          errorMessage: this.state.errorMessage
        }
      );
    });
    __publicField(this, "onFilterChanged", (filterText, currentPersonas, limitResults) => {
      if (filterText) {
        const searchPayload = {
          workspaceId: this.props.workspaceId,
          searchStr: filterText,
          count: this.resultLimit,
          fetchPhoto: !!this.props.fetchPhoto,
          domains: this.props.tenantId === MSFT_TENANT_ID ? "" : this.state.selectedKeys.join(",")
        };
        pickerCalloutProps.hidden = false;
        suggestionProps.suggestionsHeaderText = "";
        const searchResult = SubscriberResources.search(searchPayload);
        const convertedReuslt = searchResult.then((r) => {
          if (EnvironmentService.enableUnifiedAPIOfSubscribeMode()) {
            return this.removeDuplicates(convertSubscribersV2(convertSubscribersToUnified(r.getSuccessData())), currentPersonas);
          } else {
            return this.removeDuplicates(convertSubscribers(r.getSuccessData()), currentPersonas);
          }
        }).catch((e) => {
          this.setState({ errorMessage: `${ERROR_TYPES.SEARCH_FAILED} ${e}` });
          return [];
        });
        return convertedReuslt;
      } else {
        return [];
      }
    });
    __publicField(this, "removeDuplicates", (personas, possibleDupes) => {
      const result = personas.filter((persona) => !this.listContainsPersona(persona, possibleDupes));
      if (result.length >= this.resultLimit) {
        suggestionProps.suggestionsHeaderText = `Top ${this.resultLimit} suggested results`;
        suggestionProps.className = "ms-PeoplePicker-suggestion";
      } else {
        suggestionProps.suggestionsHeaderText = "";
      }
      this.setState({ errorMessage: "" });
      return result;
    });
    __publicField(this, "listContainsPersona", (persona, personas) => {
      if (!personas || !personas.length || personas.length === 0) {
        return false;
      }
      return personas.filter((item) => item.text === persona.text).length > 0;
    });
    __publicField(this, "onRenderSuggestionItem", (personaProps, suggestionsProps) => {
      const secondaryTextFormted = !!personaProps.tertiaryText ? personaProps.secondaryText + " | " + personaProps.tertiaryText : personaProps.secondaryText;
      return /* @__PURE__ */ jsx(
        PeoplePickerItemSuggestion,
        {
          personaProps: __spreadProps(__spreadValues({}, personaProps), {
            styles: personaStyles,
            secondaryText: secondaryTextFormted
          }),
          suggestionsProps
        }
      );
    });
    __publicField(this, "onItemsChange", (items) => {
      this.setState({
        currentSelected: items,
        errorMessage: this.props.required && (items == null ? void 0 : items.length) === 0 ? ERROR_TYPES.REQUIRED : ""
      });
      if (!!this.props.onChange) {
        this.props.onChange(items);
      }
    });
    __publicField(this, "onInputChange", (input) => {
      const outlookRegEx = /<.*>/g;
      const emailAddress = outlookRegEx.exec(input);
      if (emailAddress && emailAddress[0]) {
        return emailAddress[0].substring(1, emailAddress[0].length - 1);
      }
      return input;
    });
    __publicField(this, "validateInput", (input) => {
      if (input.indexOf("@") !== -1 && EmailDomainList.includes("@" + input.split("@")[1])) {
        this.setState({ errorMessage: "" });
        return ValidationState.valid;
      } else if (!input) {
        this.setState({ errorMessage: "" });
        return ValidationState.invalid;
      } else {
        this.setState({ errorMessage: ERROR_TYPES.INVALID });
        return ValidationState.invalid;
      }
    });
    __publicField(this, "onInputClick", (ev) => {
      pickerCalloutProps.calloutWidth = ev.currentTarget.clientWidth + ev.currentTarget.offsetLeft;
      if (!this.state.selectedKeys || this.state.selectedKeys.length === 0) {
        this.setState({
          selectedKeys: this.getDropdownOptions(this.tenantId).map((o) => o.key)
        });
      }
    });
    __publicField(this, "onInputBlur", (ev) => {
      if (!this.state.errorMessage.startsWith(ERROR_TYPES.SEARCH_FAILED)) {
        if (!!ev.target.defaultValue) {
          this.setState({
            errorMessage: ERROR_TYPES.INVALID
          });
        } else if (!this.state.currentSelected || this.state.currentSelected.length === 0) {
          this.setState({
            errorMessage: this.props.required ? ERROR_TYPES.REQUIRED : ""
          });
        } else {
          this.setState({
            errorMessage: ""
          });
        }
      }
      this.setState({ isFocus: false });
    });
    __publicField(this, "onDomainDropdownChange", (event, option, index) => {
      if (option) {
        const allKeys = this.getDropdownOptions(this.tenantId).map((o) => o.key);
        if (option.key === "") {
          this.setState({
            selectedKeys: option.selected ? allKeys : []
          });
        } else if (allKeys.length >= 2 && this.state.selectedKeys.length === allKeys.length - 2) {
          this.setState({
            selectedKeys: option.selected ? allKeys : this.state.selectedKeys.filter((key) => key !== option.key).filter((key) => key !== "")
          });
        } else {
          this.setState({
            selectedKeys: option.selected ? [...this.state.selectedKeys, option.key] : this.state.selectedKeys.filter((key) => key !== option.key).filter((key) => key !== "")
          });
        }
        pickerCalloutProps.hidden = true;
      }
    });
    __publicField(this, "onCheckBoxChange", (ev, checked) => {
      const selectedItems = this.state.currentSelected;
      const currentUser = EnvironmentService.getUser();
      if (checked) {
        let indexMe = selectedItems == null ? void 0 : selectedItems.findIndex((item) => item.text === currentUser.displayName);
        if (indexMe < 0) {
          let currentSubscriber = {
            id: currentUser.oid,
            text: currentUser.displayName,
            secondaryText: currentUser.email,
            type: "UserAccount",
            tenantId: currentUser.tid,
            subscriptionType: SUBSCRIPTION_TYPES.EntityBase
          };
          selectedItems.push(currentSubscriber);
          this.setState({ currentSelected: selectedItems, errorMessage: "" });
          if (!!this.props.onChange) {
            this.props.onChange(selectedItems);
          }
        }
      } else {
        const displayName = currentUser.displayName;
        const indexMe = selectedItems == null ? void 0 : selectedItems.findIndex((item) => item.text === displayName);
        if (indexMe >= 0 && !!selectedItems) {
          const newItems = [...selectedItems.slice(0, indexMe), ...selectedItems.slice(indexMe + 1)];
          this.setState({
            currentSelected: newItems,
            errorMessage: this.props.required && newItems.length === 0 ? ERROR_TYPES.REQUIRED : ""
          });
          if (!!this.props.onChange) {
            this.props.onChange(newItems);
          }
        }
      }
    });
    __publicField(this, "IsUserInSubscribers", () => {
      let include = false;
      const subscribers = this.state.currentSelected;
      const currentUser = EnvironmentService.getUser();
      include = subscribers.filter((i) => i.id === currentUser.oid).length > 0;
      return include;
    });
    __publicField(this, "getDropdownOptions", (tenantId) => {
      if (tenantId === TORUS_TENANT_ID) {
        const options = [{ key: MSFT_TENANT_ID, text: TenantNamesById[MSFT_TENANT_ID] }];
        return options;
      } else if (!!tenantId && tenantId !== MSFT_TENANT_ID) {
        const options = [
          { key: tenantId, text: TenantNamesById[tenantId] },
          { key: MSFT_TENANT_ID, text: TenantNamesById[MSFT_TENANT_ID] }
        ];
        const sortedOptions = options.sort((optionA, optionB) => optionA.text > optionB.text ? 1 : -1);
        return [{ key: "", text: TIPS.DROPDOWN_ALL_TEXT }, ...sortedOptions];
      } else {
        return [];
      }
    });
    __publicField(this, "needLoadSubscribersOnmount", (useUnifiedAPI) => {
      var _a, _b, _c, _d;
      let result = false;
      if (!this.props.skipLoadOnMount && this.props.isUpdateEntity && !!this.props.entityType && !!this.props.entityExternalId) {
        if (useUnifiedAPI && !requestPending((_a = this.props.subscribersAsyncV2) == null ? void 0 : _a.status) && !requestPending((_b = this.props.setSubscribersAsyncV2) == null ? void 0 : _b.status)) {
          result = true;
        } else {
          if (!useUnifiedAPI && !requestPending((_c = this.props.subscribersAsync) == null ? void 0 : _c.status) && !requestPending((_d = this.props.setSubscribersAsync) == null ? void 0 : _d.status)) {
            result = true;
          }
        }
      }
      return result;
    });
    this.pickerRef = React.createRef();
    this.tenantId = !!this.props.tenantId ? this.props.tenantId : EnvironmentService.getUser().tid;
    this.state = {
      currentSelected: [],
      selectedKeys: this.getDropdownOptions(this.tenantId).map((o) => o.key),
      errorMessage: this.props.errorMessage || "",
      isFocus: false
    };
  }
  componentDidMount() {
    var _a, _b, _c, _d;
    if (EnvironmentService.enableUnifiedAPIOfSubscribeMode() && this.needLoadSubscribersOnmount(true)) {
      (_b = (_a = this.props).loadSubscribersV2) == null ? void 0 : _b.call(_a, {
        workspaceId: this.props.workspaceId,
        entityType: this.props.entityType,
        entityExternalId: this.props.entityExternalId,
        fetchPhoto: !!this.props.fetchPhoto,
        notificationCategory: this.props.notificationCategory
      });
    } else if (!EnvironmentService.enableUnifiedAPIOfSubscribeMode() && this.needLoadSubscribersOnmount(false)) {
      (_d = (_c = this.props).loadSubscribers) == null ? void 0 : _d.call(_c, {
        workspaceId: this.props.workspaceId,
        entityType: this.props.entityType,
        entityExternalId: this.props.entityExternalId,
        fetchPhoto: !!this.props.fetchPhoto,
        includeUser: this.props.isReadOnly
      });
    } else if (!!this.props.subscribers) {
      this.setState({ currentSelected: this.props.subscribers });
    }
  }
  componentDidUpdate(prevProps) {
    var _a;
    if (EnvironmentService.enableUnifiedAPIOfSubscribeMode()) {
      const prevData = prevProps.subscribersAsyncV2;
      const thisData = this.props.subscribersAsyncV2;
      if (!!prevData && !!thisData && (prevData == null ? void 0 : prevData.data) !== (thisData == null ? void 0 : thisData.data) && requestPending(prevData.status) && requestCompleted(thisData.status)) {
        let subscribers = getMergedSubscribers(
          thisData.data,
          this.props.notificationCategory,
          this.props.experimentationGroupId
        );
        this.setState({ currentSelected: convertSubscribersV2(subscribers) });
      }
    } else {
      const prevData = prevProps.subscribersAsync;
      const thisData = this.props.subscribersAsync;
      if (!!prevData && !!thisData && (prevData == null ? void 0 : prevData.data) !== (thisData == null ? void 0 : thisData.data) && requestPending(prevData.status) && requestCompleted(thisData.status)) {
        this.setState({ currentSelected: convertSubscribers((_a = thisData.data) == null ? void 0 : _a.subscribers) });
      }
    }
  }
  render() {
    return /* @__PURE__ */ jsx(ErrorBoundary, { children: this.renderSubscriberPicker() });
  }
}
const LoadPickSubscribers = connect(
  mapState,
  mapDispatch
)(Component);
export {
  Component,
  LoadPickSubscribers,
  LoadPickSubscribers as default
};
//# sourceMappingURL=LoadPickSubscribers.js.map
